__turbopack_context__.v({
  "content": "HeroCampaignBanner-module__OmIjhW__content",
  "deep": "HeroCampaignBanner-module__OmIjhW__deep",
  "heading": "HeroCampaignBanner-module__OmIjhW__heading",
  "modalWrapper": "HeroCampaignBanner-module__OmIjhW__modalWrapper",
  "wrapper": "HeroCampaignBanner-module__OmIjhW__wrapper",
});
